import { useState, useEffect, useCallback } from 'react';
import { safeGetItem, safeSetItem } from '@/lib/safeStorage';

const STORAGE_KEY = 'human-rooms-reading-mode';

export const useReadingMode = () => {
  const [isEnabled, setIsEnabled] = useState(() => {
    const stored = safeGetItem(STORAGE_KEY);
    return stored === 'true';
  });

  useEffect(() => {
    safeSetItem(STORAGE_KEY, String(isEnabled));
    
    // Apply reading mode class to document
    if (isEnabled) {
      document.documentElement.classList.add('reading-mode');
    } else {
      document.documentElement.classList.remove('reading-mode');
    }
  }, [isEnabled]);

  // Global keyboard shortcut: R for reading mode
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) return;

      if (e.key === 'r' && !e.ctrlKey && !e.metaKey && !e.altKey) {
        setIsEnabled(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const toggle = useCallback(() => {
    setIsEnabled(prev => !prev);
  }, []);

  return {
    isEnabled,
    toggle,
    setIsEnabled,
  };
};
